var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-login"},[_c('Login',{attrs:{"loginType":'ctrl'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }